import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { IRuleViolation } from '../Interfaces/Application/IApplicationQuote';
import { uniq } from 'ramda';
export interface ValidationDialogProps {

}

export const ValidationDialog: React.FC<ValidationDialogProps> = props => {  
  const [refresh, setRefresh] = useState({});
  useEffect(() => {
    _refresh = () => setRefresh({});
    return () => {
      _refresh = () => {};
    }
  }, []);
  // const canBypass = _allowBypass=== true || _errors.filter(e => typeof e !== 'string' && e.type === 'error') === undefined;
  const errors = uniq(_errors);

  return (
  <Dialog
    open={_errors?.length > 0}
    onClose={clear}
  >
    <DialogTitle>{_allowBypass ? 'Bypass requirements?' : 'Errors and Warnings'}</DialogTitle>
    <DialogContent>
      <DialogContentText>
        This application does not meet all requirements.
      </DialogContentText>
      <ul>
        {errors.map((e, i) => 
        <li key={i} style={{color: typeof e !== 'string' && e.type === 'error' ? 'red' : 'black' }}>
          {typeof e === 'string' ? e : e.message}
        </li>
        )}
      </ul>
      {_allowBypass && (
        <DialogContentText>
          Would you like to bypass these requirements?
        </DialogContentText>
      )}      
    </DialogContent>
    <DialogActions>
      <Button onClick={clear} color="inherit" autoFocus>
        Cancel
      </Button>
      {_allowBypass && (
        <Button onClick={() => {
          const cb = _callback;
          clear();
          cb();
        }}
          color="primary"
        >
          Bypass
        </Button>
      )}
    </DialogActions>
  </Dialog>
  );
}

const clear = () => {
  _errors = [];
  _callback = () => {};
  _refresh();
}

let _errors: (string | IRuleViolation)[] = [];
let _callback = () => {};
let _refresh = () => {};
let _allowBypass = true;

export const showValidationDialog = (
  props: {
    errors: (string | IRuleViolation)[], 
    callback: () => void,
    title?: string,
    message?: string,
    allowBypass?: boolean;
  }
) => {
  _errors = props.errors || [];
  _callback = props.callback || (() => {});
  _refresh();
  _allowBypass = props.allowBypass === false ? false : true;
}
